import type { ActionVariantKey } from 'components/UserActions/PokerActions/actionVariants';

/**
 * AC-5.2's universal colour tokens: 1X/decline = blue, 2X = green, 3X = the
 * primary orange of `raise` (Sevs, 2026-09-17, replacing the AC's original
 * yellow — a one-off saloon gold that existed only here). The vote row draws
 * exclusively from fills the action row already uses.
 *
 * Shared by the vote buttons and the felt's RUN IT text (EN-10856), so a count
 * cannot be one colour on the button and another on the felt. The bubble side
 * of "everywhere" is `MULTI_RUN_COLORS` in SeatAction.tsx, which carries the
 * same three colours for the same three choices.
 */
export const RUN_VARIANT: Record<number, ActionVariantKey> = {
  1: 'check', // blue
  2: 'call', // green
  3: 'raise' // primary orange — the Raise button's fill
};
